// import moment from 'moment'
import { Config } from './Config'
// import * as UserContext from '../src/components/Common/UserContext'
import AuthenticationService from './components/Security/AuthenticationService'
// import { CommonConstants } from '../src/Constants'
/***
GET, POST and DELETE api methods to be called from different components across the application.
*/

class Api {
  constructor () {
    this.authService = new AuthenticationService(Config.authBaseUrl)
  }
  /* Method for POST API calls */
  postData (url, data, callback, errorCallback, headers) {
    // let token = UserContext.getToken()

    if (!headers) {
      headers = {}
      if (this.authService.getToken()) {
        headers = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.authService.getToken()
        }
      } else {
        headers = {
          'Content-Type': 'application/json'
        }
      }
    }
    window.fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    })
      .then((response) => response.json())
      .then(callback)
      .catch((error) => {
        if (errorCallback) {
          errorCallback(error)
        }
        console.log(error)
      })
      .then((response) => response.json())
      .then(callback)
      .catch((error) => {
        if (errorCallback) {
          errorCallback(error)
        }
        console.log(error)
      })
  }

  /* Method for GET API calls */
  getData (url, callback) {
    // let token = UserContext.getToken()
    window.fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.authService.getToken()
      }
    })
      .then((response) => response.json())
      .then(callback)
      .catch((error) => {
        console.log(error)
      })
  }

  /* Method for POST API calls */

  deleteData (url, callback) {
    // let token = UserContext.getToken()
    window.fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.authService.getToken()
      }
    })
      .then((response) => response.json())
      .then(callback)
      .catch((error) => {
        console.log(error)
      })
  }

  /**
   * DTDS Remote Execution Service Calls
   * @param {string} api Service call api absolute path
   * @param {function} callBack Return value to the called function
   */
  RemoteExecutionServiceCall (api, callBack) {
    const { useFacade, actionUrl, facadeToken } = Config
    let _headers = {
      'content-type': 'application/json'
    }
    let _url = actionUrl + 'RemoteExecution/' + api
    if (useFacade) {
      _headers = {
        'Authorization': 'Basic ' + facadeToken,
        'content-type': 'application/json'
      }
      _url = actionUrl + 'api/facade/RemoteExecution/' + api
    }
    window.fetch(_url, {
      headers: _headers
    })
      .then((response) => response.json())
      .then(callBack)
      .catch((error) => {
        console.log(error)
      })
  }

  getPublicIp () {
    return new Promise((resolve, reject) => {
      const doReject = () => reject(new Error('Couldn\'t find your IP'))
      const xhr = new window.XMLHttpRequest()

      xhr.onerror = doReject
      xhr.ontimeout = doReject
      xhr.onload = () => {
        const ip = xhr.responseText.trim()
        resolve(ip)
      }

      xhr.open('GET', 'https://ipv4.icanhazip.com/')
      xhr.timeout = 5000
      xhr.send()
    })
  }
}

export default Api



// WEBPACK FOOTER //
// ./src/Api.js